import styled from 'styled-components';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';

export const QuoteTrackingText = styled(TextPairing)`
  flex-direction: column-reverse;
  position: relative;
  .text-pairing-title {
    max-width: 400px;
    padding-bottom: ${themeSpace(7)};
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 470px;
    }
  }
`;

export const QuoteColumn = styled(Columns.Column)`
  display: flex;
  align-items: center;
`;

export const ImageColumn = styled(Columns.Column)`
  ${themeMediaQuery('xl')} {
    margin-left: 0;
  }
`;
